import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../i18n';

/** Two-option language switch; 44px targets, current option announced via aria-pressed. */
export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? 'en') as SupportedLanguage;
  return (
    <div role="group" aria-label={t('nav.language')} className="flex rounded-md bg-surface-2 p-0.5">
      {SUPPORTED_LANGUAGES.map((lng) => {
        const active = lng === current;
        return (
          <button
            key={lng}
            type="button"
            lang={lng}
            aria-pressed={active}
            onClick={() => void i18n.changeLanguage(lng)}
            className={[
              'min-h-10 min-w-11 rounded-sm px-2.5 text-sm font-medium transition-colors duration-[var(--pa-dur-fast)]',
              active ? 'bg-surface text-ink shadow-sm' : 'text-ink-2 hover:text-ink',
            ].join(' ')}
          >
            {t(`language.${lng}`)}
          </button>
        );
      })}
    </div>
  );
}
